module.exports = __webpack_public_path__ + "static/10-422aad8fa1ea40367783b78fca3ecdf2.jpg";